/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { SecurityHelper, NotFoundPage } from 'sarsaparilla';

export default function SearchDebugPage() {
    const iframeRef = useRef(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        axios
            .get(`${process.env.API}/search/debug`, {
                headers: { Authorization: SecurityHelper.getAuthHeader() },
                responseType: 'text',
            })
            .then((response) => {
                if (iframeRef.current) {
                    iframeRef.current.srcdoc = response.data;
                }
            })
            .catch(() => {
                setError(true);
            });
    }, []);

    if (error) {
        return <NotFoundPage />;
    }

    return (
        <iframe
            ref={iframeRef}
            title="Search Debug UI"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                border: 'none',
                background: '#1b1e2b',
                zIndex: 9999,
            }}
        />
    );
}
